import axios from 'axios'

const tokenKey = 'foodairway_restaurant_web_token'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.foodairway.com/api',
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'X-Restaurant-Client': 'web',
    'X-Restaurant-Sound-Capabilities': 'restaurant_loud_alert',
  },
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(tokenKey)
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if ([401, 419].includes(Number(error.response?.status)) && !String(error.config?.url || '').includes('/auth/otp/')) {
      localStorage.removeItem(tokenKey)
      window.dispatchEvent(new CustomEvent('restaurant-session-expired'))
    }
    return Promise.reject(error)
  },
)

export function saveApiToken(token: string) {
  localStorage.setItem(tokenKey, token)
}

export function clearApiToken() {
  localStorage.removeItem(tokenKey)
}

export function hasApiToken() {
  return Boolean(localStorage.getItem(tokenKey))
}

export function apiError(error: unknown, fallback = 'Something went wrong. Please try again.') {
  if (!axios.isAxiosError(error)) return fallback
  const errors = error.response?.data?.errors
  if (errors && typeof errors === 'object') {
    const first = Object.values(errors).flat().find(Boolean)
    if (first) return String(first)
  }
  return String(error.response?.data?.message || fallback)
}
